<template>
  <BaseNew @new-confirm-action="createEntry" @new-cancel-action="resetForm" @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors" ref="baseNew" :newTitle="'Adicionar ' + typeText"
    :newCreateButtonLabel="'Adicionar ' + typeText" width="50%" :formErrors="formErrors" :loading="loading"
    :pageLoading="pageLoading" :modelNameSingular="modelNameSingular" :createButtonDisabled="createButtonDisabled">
    <template slot="newForm">
      <Form ref="form" :entry="entry" :extraData="extraData" :totals="totals" :typeText="typeText"
        :modelType="modelType" :modelNameSingular="modelNameSingular" />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';

import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    extraData2: {
      type: Object,
      default: {},
    },
    totals: Object,
    createButtonDisabled: Boolean,
    typeText: {
      type: String,
      default: "Pagamento"
    },
    modelType: {
      type: String,
    },
    modelNameSingular: String,
  },
  created() {
    // console.log("created");

  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function () {
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: NEW_PAYMENT_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.entry = response.data.accountContext.payment;
          if (this.extraData2) {
            console.log("extra2", this.extraData2);
            this.entry.value = this.extraData2.totalCarriageValue;
          }
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    createEntry: function () {
      if (this.$refs.form.isFormValid()) {
        this.$refs.baseNew.closeDialog();
        this.$emit("entry-created", this.entry);
        this.resetForm();
      }
    },
    resetForm: function () {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function () {
      this.formErrors = [];
    }
  }
};
const NEW_PAYMENT_QUERY = gql`
  {
    accountContext {
      payment {
        id
        initialDate
        installmentsIntervalId
        installmentsInterval {
          id
          description
          intervalInDays
        }
        paymentConditionId
        paymentCondition {
          id
          description
          numberOfInstallments
        }
        value
        paymentMethodId
        validations
        paymentMethod {
          id
        }
        bankAccountId
        bankAccount {
          id
        }
        installmentsAttributes { 
          id
        }
        
      }
    }
    globalContext {
      allGlobalPaymentMethods {
        id
        name
      }
      allInstallmentsIntervals {
        id
        description
        intervalInDays
      }
    }
  }
`;
</script>

<style scoped></style>